<template>
  <div class="flex flex-col">
    <el-card>
      <KpiList :data="list"></KpiList>
    </el-card>
    <div class="flex-1 flex mt-14px h-[calc(100% - 120px)] overflow-hidden">
      <div class="flex flex-col flex-1 h-full">
        <el-card class="flex-1 ">
          <div class="h-full  flex flex-col   rounded-4px">
            <div class="flex justify-between items-center mb-12px">
              <p class="border-l-3 border-color-primary pl-10px text-18px">各单位考试情况</p>
              <div class="flex items-center ">
                <div class="w-289px border-color-primary border-1 border-solid flex mr-14px">
                  <el-button-group class="w-full flex">
                    <el-button
                      :round="false"
                      class=" flex-1 text-center !rounded-none h-32px leading-32px cursor-pointer"
                      v-for="(item, index) in tabList"
                      :key="index"
                      @click="tabClick(index)"
                      :type="tabIndex == index ? 'primary' : ''"
                    >
                      {{ item }}
                    </el-button>
                  </el-button-group>
                  <!-- <p
                  v-for="(item, index) in tabList"
                  :key="index"
                  class="flex-1 text-center h-32px leading-32px cursor-pointer"
                  @click="tabClick(index)"
                  :class="[
                    tabIndex == index
                      ? 'text-white bg-$contentBgColor'
                      : 'text-color-primary bg-white',
                  ]"
                >
                  {{ item }}
                </p> -->
                </div>
              </div>
            </div>
            <div class="flex-1">
              <v-chart
                ref="unitRef"
                v-loading="unitLoading"
                :options="barOptions"
                autoresize
                :theme="currentTheme"
                class="w-full h-full"
              ></v-chart>
            </div>
          </div>
        </el-card>
        <div class="flex-1 flex pt-12px overflow-hidden">
          <el-card class="flex-1">
            <div class="h-full flex flex-col     rounded-4px overflow-hidden">
              <div class="flex justify-between items-center my-12px">
                <p class="border-l-2 border-color-primary h-26px pl-8px">考试通过情况</p>
                <el-date-picker
                  class="mr-10px mb-10px"
                  v-model="examDatePickerValue"
                  @change="changeExamPicker"
                  format="yyyy-MM-dd"
                  size="small"
                  type="daterange"
                  :clearable="true"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
              <v-chart
                v-loading="examPassLoading"
                :options="passExamOptions"
                autoresize
                :theme="currentTheme"
                class="w-full  flex-1"
              ></v-chart>
            </div>
          </el-card>
          <el-card class="flex-1 ml-12px">
            <div class="h-full flex flex-col     rounded-4px overflow-hidden">
              <div class="flex justify-between items-center mt-12px">
                <p class="border-l-2 border-color-primary h-26px pl-8px">考试类型分类</p>
                <el-date-picker
                  class="mr-10px mb-10px"
                  v-model="typeDatePickerValue"
                  @change="changeTypePicker"
                  format="yyyy-MM-dd"
                  size="small"
                  type="daterange"
                  :clearable="true"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
              <v-chart
                v-loading="typeLoading"
                :options="pieOption"
                autoresize
                :theme="currentTheme"
                class="w-full  flex-1"
              ></v-chart>
            </div>
          </el-card>
        </div>
      </div>
      <el-card class=" h-full w-430px ml-15px overflow-y-auto ">
        <Ranking
          :data="rankingList"
          :examSessionList="examSessionList"
          @changeExamSession="getExamRank"
        ></Ranking>
      </el-card>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import { ContractorApi } from '@wiz-api/contractor-management'
import { ExamCountOverviewApi } from '@wiz-api/exam-management'
import { TrainingPlanApi } from '@wiz-api/training-management'
import Ranking from '../../components/Ranking'
import KpiList from '../../components/KpiList'

const examCountOverviewApi = new ExamCountOverviewApi()
const trainingPlanApi = new TrainingPlanApi()
const contractorManagement = new ContractorApi()
export default {
  components: {
    KpiList,
    Ranking,
  },
  computed: {
    ...mapGetters({ currentTheme: 'System/currentTheme' }),
  },
  data() {
    return {
      organizationUnitIdsList: [],
      pieDataList: [],
      passExamList: [],
      examSessionList: [],
      typeLoading: false,
      examPassLoading: false,
      unitLoading: false,
      examDatePickerValue: [
        dayjs(new Date())
          .startOf('month')
          .format('YYYY-MM-DD'),
        dayjs(new Date()).format('YYYY-MM-DD'),
      ],
      typeDatePickerValue: [
        dayjs(new Date())
          .startOf('year')
          .startOf('day')
          .format('YYYY-MM-DD'),
        dayjs(new Date()).format('YYYY-MM-DD'),
      ],
      tabIndex: 0,
      unitSelect: '',
      unitOptions: [
        {
          value: '全部',
          label: '全部',
        },
        {
          value: '全部',
          label: '厂内人员',
        },
        {
          value: '全部',
          label: '场外人员',
        },
      ],
      tabList: ['近一个月', '近半年'],
      rankingList: [],
      list: [
        {
          label: '当前总题目',
          value: 0,
          unit: '道',
          key: 'currentTopicTotalCount',
          iconName: 'icon-bg-totallyNumber',
          color: '#21e4d6',
          bgColor: 'rgba(211, 251, 244, 1)',
        },
        {
          label: '年度考试单位',
          value: 0,
          unit: '个',
          key: 'annualExamUnitTaotalCount',
          iconName: 'icon-bg-examinationUnit',
          color: '#fd9b39',
          bgColor: '#fbe4cb',
        },
        {
          label: '年度培训人数',
          value: 0,
          unit: '人',
          key: 'personTotalCount',
          iconName: 'icon-bg-trainVenue',
          color: '#f7505a',
          bgColor: '#ffced1',
        },
        {
          label: '年度培训场次',
          value: 0,
          unit: '场',
          key: 'sessionTotalCount',
          iconName: 'icon-bg-trainPeopel',
          color: '#6fc8fb',
          bgColor: '#e3f5fb',
        },
        {
          label: '年度考试场次',
          value: 0,
          unit: '场',
          key: 'annualExamSessionTaotalCount', // sessionTotalCount
          iconName: 'icon-bg-examSessions',
          color: '#5262e2',
          bgColor: '#ccdffb',
        },
      ],
      kpiList: [],
      chartLoading: false,
      barDataset: [],
      barOptions: {
        legend: {
          type: 'scroll',
        },
        tooltip: {
          appendToBody: true,
          show: true,
          trigger: 'axis',
          confine: true,
          formatter: (params) => {
            const labelNameList = params[0].dimensionNames
            const valueList = params[0].data
            let res = ''
            valueList.forEach((item, index) => {
              if (!index || item === 0) {
                // || item === '0' || !item
                return
              }
              res += `${labelNameList[index]}:${item}%<br/>`
            })
            setTimeout(() => {
              const toolDom = document.querySelector('#tool')
              // 鼠标移出tooltip后，tooltip消失
              toolDom.addEventListener('mouseout', () => {
                toolDom.style.display = 'none'
              })
            })
            return `<div id="tool" style="max-height: 500px;overflow-y: auto;">${res}</div>`
          },
          enterable: true,
        },
        xAxis: {
          type: 'category',
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              return `${value}%`
            },
          },
        },
        dataset: {
          source: [],
        },
        series: [],
        dataZoom: [
          {
            show: true,
            xAxisIndex: [0],
            type: 'slider',
            start: 0,
            end: 30,
            bottom: -10,
          },
        ],
      },
      passExamOptions: {
        color: '#5087ec',
        tooltip: {
          show: true,
          formatter: '{b}: {c}%',
        },
        series: [
          {
            type: 'bar',
            barMaxWidth: 40,
            data: [],
          },
        ],
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            align: 'center',
            interval: 0,
            // rotate: 50,
            formatter(params) {
              let str = ''
              const paramsLength = params.length
              const len = 5
              // || Math.ceil(paramsLength / len)
              const row = 2
              if (paramsLength > len) {
                for (let i = 0; i < row; i++) {
                  let temp = ''
                  const start = i * len
                  const end = start + len
                  if (i == Math.ceil(paramsLength / len) - 1) {
                    temp = params.substring(start, paramsLength)
                  } else {
                    temp = `${params.substring(start, end)}\n`
                  }
                  str += temp
                }
              } else {
                str = params
              }
              return str
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              return `${value}%`
            },
          },
        },
        grid: {
          top: 10,
          // left: '18%',
          bottom: '38%',
        },
        dataZoom: [
          {
            show: true,
            xAxisIndex: [0],
            type: 'slider',
            startValue: 0,
            endValue: 5,
            bottom: -10,
          },
        ],
      },
      pieOption: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        grid: {
          top: 10,
        },
        legend: {
          orient: 'horizontal',
          height: 'auto',
          bottom: 4,
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '50%'],
            data: [],
            center: ['50%', '40%'],
            avoidLabelOverlap: true,
            labelLayout: 'force',
            labelLine: {
              show: true,
            },
            label: {
              show: true,
              formatter: '{b}: {c}',
            },
          },
        ],
      },
    }
  },
  created() {
    // this.getTrainingCount()
    this.getContractorManagementList()
    this.getOverviewCount()
    this.getUnitExam()
    this.getExamType()
    this.getPassExam()
    this.getExamSessionList()
  },
  mounted() {
    this.$refs.unitRef.chart.on('click', (e) => {
      const { dataIndex, seriesIndex } = e
      const id = this.barDataset[dataIndex][seriesIndex]
      const url = Wiz?.globalSettings?.globalConfig?.routerBase
        ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/exam-manage/exam-record-info`
        : '/educational-training-management-sm/exam-manage/exam-record-info'
      this.$router.push({
        path: url,
        query: {
          id,
        },
      })
    })
  },
  methods: {
    async getContractorManagementList() {
      const [err, res] = await contractorManagement.getContractorOrganizationUnitList({
        contractorStatus: 1,
      })
      if (!err) {
        this.organizationUnitIdsList = res.map((item) => {
          return item.orgId
        }) // 厂内人员
        this.getTrainingCount()
      }
    },
    async getTrainingCount() {
      const [err, res] = await trainingPlanApi.getPostAnnualStatistics({
        body: {
          endTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          startTime: dayjs()
            .startOf('year')
            .format('YYYY-MM-DD HH:mm:ss'),
          organizationUnitIds: this.organizationUnitIdsList,
        },
      })
      if (!err) {
        const keys = Object.keys(res)
        this.list.forEach((item) => {
          const key = item.key
          if (keys.includes(key)) {
            item.value = res[key] || 0
          }
        })
      }
    },
    // 总的统计
    async getOverviewCount() {
      const [err, res] = await examCountOverviewApi.getExamCountOverview()
      if (!err) {
        const keys = Object.keys(res)
        this.list.forEach((item) => {
          const key = item.key
          if (keys.includes(key)) {
            item.value = res[key] || 0
          }
        })
      }
    },
    async getUnitExam() {
      this.$refs.unitRef && this.$refs.unitRef.chart.clear()
      this.unitLoading = true
      this.barOptions.dataset = {
        source: [],
      }
      this.barOptions.series = []
      const [err, res] = await examCountOverviewApi.getExamUnitSituation(this.tabIndex)
      if (!err) {
        this.barOptions.dataset.source[0] = ['product']
        res.map((item, index) => {
          this.barOptions.dataset.source[index + 1] = [item.departmentName]
          this.barDataset[index] = []
          item.childs &&
            item.childs.map((child, Cindex) => {
              // this.barOptions.dataset.source[index + 1].push(child.tatalCount)
              if (!this.barOptions.dataset.source[0].includes(child.examName)) {
                this.barOptions.dataset.source[0].push(child.examName)
                this.barOptions.series.push({
                  type: 'bar',
                })
              }
            })
        })
        res.map((department, departmentIndex) => {
          // 考试名称
          this.barOptions.dataset.source[0].map((item, itemIndex) => {
            if (!itemIndex) {
              return
            }
            let flag = false
            let passRateStr = 0
            let examPlanId = ''
            // 单位名称
            for (let i = 0; i < department.childs.length; i++) {
              const child = department.childs[i]
              if (child.examName == item) {
                flag = true
                passRateStr = child.passRateStr.split('%')[0]
                examPlanId = child.examPlanId
              }
            }
            if (flag) {
              this.barOptions.dataset.source[departmentIndex + 1].push(passRateStr)
            } else {
              this.barOptions.dataset.source[departmentIndex + 1].push(0)
            }
            this.barDataset[departmentIndex].push(examPlanId)
          })
        })
        let end
        const seriesLength = this.barOptions.series.length
        if (seriesLength < 100) {
          end = (seriesLength / 100) * 100
          end = 100 - end
          this.barOptions.dataZoom[0].end = end
        } else {
          end = 100 / seriesLength

          this.barOptions.dataZoom[0].end = end
        }
        console.log(this.barOptions, end)
      }
      this.unitLoading = false
    },

    // 获取考试类型
    async getExamType() {
      this.typeLoading = true
      const [err, res] = await examCountOverviewApi.getExamCategoryCount({
        startTime: this.typeDatePickerValue[0],
        endTime: this.typeDatePickerValue[1],
      })
      this.typeLoading = false
      if (!err) {
        this.pieOption.series[0].data = res.map((item) => {
          return {
            name: item.categoryName,
            value: item.count,
          }
        })
        // this.pieOption.series[0].data = this.pieDataList
      }
    },
    // 考试通过情况
    async getPassExam() {
      this.examPassLoading = true
      const [err, res] = await examCountOverviewApi.getExamPassSituation({
        startTime: this.examDatePickerValue[0],
        endTime: this.examDatePickerValue[1],
      })
      this.examPassLoading = false
      if (!err) {
        this.passExamOptions.series[0].data = res.map((item) => {
          return item.passRateStr.split('%')[0]
        })
        this.passExamOptions.xAxis.data = res.map((item) => {
          return item.examName
        })
      }
    },
    async getExamRank(ExamSessionId) {
      const [err, res] = await examCountOverviewApi.getRankCount(ExamSessionId, {
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.rankingList = res.items
      }
    },
    async getExamSessionList() {
      const [err, res] = await examCountOverviewApi.getDropDown()
      if (!err) {
        this.examSessionList = res
        if (res.length) {
          this.getExamRank(res[0].id)
        }
      }
    },
    changeTypePicker() {
      this.getExamType()
    },
    changeExamPicker() {
      this.getPassExam()
    },
    tabClick(index) {
      this.tabIndex = index
      this.getUnitExam()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-card .el-card__body {
  height: 100%;
}
</style>
